/**
 * @generated SignedSource<<0c6395281e13821d5d028f0321900902>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MergedCell$data = {
  readonly canHaveChildIssues?: boolean | null | undefined;
  readonly hasChildren?: boolean | null | undefined;
  readonly node: {
    readonly id: string;
    readonly issueId: string;
  } | null | undefined;
  readonly " $fragmentType": "MergedCell";
};
export type MergedCell$key = {
  readonly " $data"?: MergedCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"MergedCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "MergedCell",
  "selections": [
    {
      "condition": "shouldQueryHasChildren",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "filterByProjectKeys",
              "variableName": "projectKeys"
            }
          ],
          "kind": "ScalarField",
          "name": "hasChildren"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "projectKey",
              "variableName": "projectKey"
            }
          ],
          "kind": "ScalarField",
          "name": "canHaveChildIssues"
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "issueId"
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};

(node as any).hash = "5ab28427c1039e081714dcbb034b2728";

export default node;
